/** What a service-desk ticket is about (PAUL-3646). Reports from the register default to Bug. */
export enum ServiceDeskTicketType {
  Bug = 0,
  Idea = 1,
  Incident = 2,
  Question = 3,
  Other = 4,
}

export const ServiceDeskTicketTypeTranslations: Record<ServiceDeskTicketType, string> = {
  [ServiceDeskTicketType.Bug]: 'service_desk.type.bug',
  [ServiceDeskTicketType.Idea]: 'service_desk.type.idea',
  [ServiceDeskTicketType.Incident]: 'service_desk.type.incident',
  [ServiceDeskTicketType.Question]: 'service_desk.type.question',
  [ServiceDeskTicketType.Other]: 'service_desk.type.other',
};

/** `lib-select` options ({ key, value }). */
export const ServiceDeskTicketTypeOptions = [
  ServiceDeskTicketType.Bug,
  ServiceDeskTicketType.Idea,
  ServiceDeskTicketType.Incident,
  ServiceDeskTicketType.Question,
  ServiceDeskTicketType.Other,
].map((type) => ({ key: ServiceDeskTicketTypeTranslations[type], value: type }));
